import React, { useEffect, useMemo } from "react";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { Button, Form, Spin } from "antd";
import { ZEntityRow } from "src/pages/EntityFiltersPage/EntityList/types";
import { AsyncTableView } from "src/pages/EntityFiltersPage/AsyncTableView";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { ZObjectRefTable } from "src/common/attrEdit/components";
import { useNavigate } from "react-router-dom";
import { PageUrl } from "src/routes/PageUrl";
import { makeUrl } from "src/routes/makeUrl";
import { onError } from "src/common/onError";
import { ObjectRefTableStore } from "./ObjectRefTableStore";
import styles from "./ObjectRefTable.module.less";
import { ObjectRefSelectorLabel } from "../ObjectRefSelector/ObjectRefSelectorLabel";
import { EntitySelectTable } from "../EntitySelectTable";

type PropsObjectRefTable = {
  attrInfo: ZAttribute;
  component: ZObjectRefTable;
  value?: string[];
  disabled?: boolean;
  onChange?: (value?: string[]) => void;
  label: string;
  entityId?: ZUid;
};

export const ObjectRefTable: React.FC<PropsObjectRefTable> = observer(
  ({ attrInfo, component, value, disabled, onChange, label, entityId }) => {
    const store = useMemo(() => new ObjectRefTableStore(), []);
    const form = Form.useFormInstance();
    const filterField: string[] | null | undefined = Form.useWatch(
      String(attrInfo.filter),
      form,
    );
    const selectDisabled =
      (attrInfo.filter && !filterField?.length) ||
      (!!attrInfo.backlinkAttributeId && !entityId) ||
      disabled;
    const { entitySelectStore, listStore } = store;
    const inited = !!entitySelectStore?.filtersPageStore && !!listStore;

    useEffect(() => {
      store
        .init(attrInfo, component, form, value, onChange, entityId)
        .catch(onError);
    }, [attrInfo.referenceId, attrInfo.backlinkAttributeId, entityId]);

    const navigate = useNavigate();

    if (!inited) return <Spin>{t("Loading")}...</Spin>;

    return (
      <div className={styles.box}>
        <AsyncTableView<ZEntityRow, {}>
          store={listStore}
          columns={listStore.columns}
          useHeader
          usePagination
          onRowClick={({ id }) => navigate(makeUrl(PageUrl.entityCard, { id }))}
        />
        <Button
          className={styles.selectBtn}
          onClick={() => {
            entitySelectStore?.setOpen(true);
          }}
          disabled={selectDisabled}
          loading={store.loading}
        >
          {t("Select")}
        </Button>
        <EntitySelectTable
          store={entitySelectStore}
          label={label}
          form={form}
          disabled={selectDisabled}
          value={value}
          makeTag={(id) => (
            <ObjectRefSelectorLabel component={component} entityId={id} />
          )}
        />
      </div>
    );
  },
);
